// extracted by mini-css-extract-plugin
export default {"page":"CX-z","cartModal":"DX-z","checkout":"EX-z","placeholder":"FX-z","account":"GX-z"};